import { Fragment, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/solid'
import { countryPhoneCodes } from './countryPhoneCode'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const CountryCode = ({ selected, setSelected,disable }) => {
   
    return (
        <Listbox value={selected} onChange={setSelected}>
            {({ open }) => (
                <>
                    {/* <Listbox.Label className={'block text-sm text-gray-500 ml-1'}>Country</Listbox.Label> */}
                    <div className="mt-1 relative">
                        <Listbox.Button className={`h-11 relative w-full ${disable ? 'bg-gray-400' : 'bg-[#223548]'} rounded-md shadow-sm pr-10 py-2 text-left cursor-pointer  ${!open && ''} sm:text-sm`}>
                            <span className="flex items-center">
                                <span className={`ml-3 block font-semibold truncate ${ !disable ? `text-white/80` : 'text-white/80'}`}>{`${selected.name} (${selected.dial_code})`}</span>
                            </span>
                            <span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                <ChevronDownIcon className={`h-5 w-5 ${ !disable ? `text-white/80` : 'text-white'}`} aria-hidden="true" />
                            </span>
                        </Listbox.Button>

                        <Transition
                            show={open && !disable}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Listbox.Options className="absolute z-[999999] mt-1 w-[300px]  md:w-fit bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                {countryPhoneCodes.map((item) => (
                                    <Listbox.Option
                                        key={item.code}
                                        className={({ active }) =>
                                            classNames(
                                                active ? 'text-white bg-indigo-600' : 'text-gray-900',
                                                'cursor-default select-none relative py-2 pl-3 pr-9 h-11'
                                            )
                                        }
                                        value={item}
                                    >
                                        {({ selected, active }) => (
                                            <>
                                                <div className=  "flex items-center">
                                                    <span
                                                        className={classNames(selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate')}
                                                    >
                                                        {`${item.name} (${item.dial_code})`}
                                                    </span>
                                                </div>

                                                {selected ? (
                                                    <span
                                                        className={classNames(
                                                            active ? 'text-white' : 'text-indigo-600',
                                                            'absolute inset-y-0 right-0 flex items-center pr-4'
                                                        )}
                                                    >
                                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </>
            )}
        </Listbox>
    )
}

export default CountryCode